<template>
  <a :href="card.link" class="carousel-card" @click.prevent="navigateTo(card.link)">
    <img v-if="card.image" :src="card.image" :alt="card.title" class="carousel-card__image" />
    <h3 v-if="card.title" class="text-h4 text-color-navy text-color-navy carousel-card__title">
      {{ card.title }}
    </h3>
    <p v-if="card.subtitle" class="carousel-card__subtitle text-description">
      {{ card.subtitle }}
    </p>
    <button
      v-if="isExpert"
      :id="buttonId"
      class="button button--small button--secondary-inversed carousel-card__btn"
      @click.stop.prevent="onExpertBtnClick()"
      v-html="getBtnText"
    />
  </a>
</template>

<script>
import navigationMixin from '@/components/common/mixins/navigationMixin'
import screenWidthMixin from '@/components/common/mixins/screenWidthMixin'

export default {
  name: 'CarouselCard',
  mixins: [navigationMixin, screenWidthMixin],
  props: {
    card: {
      type: Object,
      default: () => {},
    },
    isExpert: {
      type: Boolean,
    },
  },
  computed: {
    firstName() {
      return this.card.title?.split(' ')[0] || ''
    },
    getBtnText() {
      return `Contact ${this.firstName}`
    },
    buttonId() {
      return `contact-expert-${this.firstName}-button`
    },
  },
  methods: {
    onExpertBtnClick() {
      this.navigateTo('https://bioivt.com/about/contact-us', '_blank')
    },
  },
}
</script>
